export const TASK_TYPE = {
  CART_VERIFY: "cart_verify",
  ENTRANCE_TRACK: "entrance_track",
  INTRUSION: "intrusion",
  TRACK: "track",
  SHELF: "shelf",
  WHO: "who",
  INSIDE_ONLY_ENTRANCE: "inside-only-entrance",
  SCAN_MATCH: "scan-match",
}

export const TASK_STATUS = {
  NEW: "New",
  IN_PROGRESS: "In Progress",
  PAUSED: "Paused",
  WAITING_FOR_EXPERT: "Waiting-for-expert",
  COMPLETED: "Completed",
  PENDING: "Pending",
}

// Pseudo task-status filter option values used only in the operator-ui task
// status dropdown - both resolve to TASK_STATUS.PENDING, but PENDING_MINE
// additionally scopes the search to tasks pending_by the current operator.
export const PENDING_FILTER = {
  MINE: "pending_mine",
  ALL: "pending_all",
}

export const SOURCE_TYPE = {
  SHELF: "shelf",
  SOURCE: "source",
  KIOSK: "kiosk",
}

export const EVENT_ITEMS_PURCHASED = "items-purchased"
export const EVENT_ACTIVITY_DETECT = "activity-detect"
export const EVENT_SHELF_CHANGE = "Shelf-Change"
export const EVENT_LOYALTY = "loyalty"
export const EVENT_RECEIPT_INPUT = "receipt-input"
export const EVENT_PERSON_ENTRY = "Person-Entry"
export const EVENT_PERSON_EXIT = "Person-Exit"
export const EVENT_PERSON_SCAN = "Person-Scan"
export const EVENT_SHOPPING = "Shopping"
export const CART_REDIS_PREFIX = "order-v2::"
export const KEY_PLANOGRAM_ISSUE = "has_planogram_issue"
export const PLANOGRAM_FLAG = "1"

export const DEFAULT_TIME_PERIOD = 30000 // 30 seconds
export const BUFFER_TIME_PERIOD = 2000 // 2 seconds

// Offset for events to load video slightly before the event (in milliseconds)
export const EVENT_TIMESTAMP_OFFSET = 30
export const MIN_DIFF_TIMESTAMP_IN_MS = 9000
export const EXIT_TIMESTAMP_OFFSET_IN_MS = 1000

export const KEYCODE_LEFT = 37
export const KEYCODE_UP = 38
export const KEYCODE_RIGHT = 39
export const KEYCODE_DOWN = 40
export const KEYCODE_A = 65
export const KEYCODE_D = 68
export const KEYCODE_ENTER = 13
export const KEYCODE_0 = 48
export const KEYCODE_9 = 57
export const KEYCODE_NUMLOCK_0 = 96
export const KEYCODE_NUMLOCK_9 = 105
export const KEYCODE_SPACE = 32
export const KEYCODE_F = 70
export const KEYCODE_S = 83
export const KEYCODE_T = 84
export const KEYCODE_E = 69
export const KEYCODE_I = 73
export const KEYCODE_H = 72
export const KEYCODE_Y = 89

export const KEY_CAPITAL_M = "M"
export const KEY_SMALL_M = "m"
export const KEY_CAPITAL_S = "S"
export const KEY_SMALL_S = "s"
export const KEY_CAPITAL_K = "K"
export const KEY_SMALL_K = "k"

export const ORDER_UNASSIGNED = "Unassigned"
export const NONE_ORDER_DISPLAY_NAME = "exit"
export const NONE_ORDER_KEY = "none"
export const STORE_CREW = "auto-tagged-as-store-crew"
export const STORE_CREW_KEY = "store crew"
export const RESTOCKER_CART_ID = "shelf-restocker-track"
export const IS_CREATED_BY_SCAN = "is_created_by_scan"
export const MISSING_CART_ID_TOKEN = "Missing Cart Id"
export const ORDER_SUBMITTED_STATUS = "submitted"
export const ORDER_PAID_FLAG = "1"

export const KEYPOINT_PAIRS = [
  ["crown", "forehead"],
  ["crown", "right_shoulder"],
  ["crown", "left_shoulder"],
  ["forehead", "right_shoulder"],
  ["forehead", "left_shoulder"],
  ["right_shoulder", "right_elbow"],
  ["left_shoulder", "left_elbow"],
  ["right_elbow", "right_wrist"],
  ["left_elbow", "left_wrist"],
]

export const KEYPOINT_COLORS = [
  "#FF0000",
  "#FFAA00",
  "#AAFF00",
  "#00FF00",
  "#00FFAA",
  "#00AAFF",
  "#0000FF",
  "#AA00FF",
  "#FFF700",
]

export const JOYRIDESTEPS = [
  {
    content: "Use this option to switch cameras",
    placement: "bottom",
    target: ".camera-grid .camera-select",
    title: "Switch Camera",
    disableBeacon: true,
  },
  {
    content: "Use keyboard navigation arrows to switch cameras",
    placement: "bottom",
    target: ".adjacent-camera",
    title: "Switch Camera",
    disableBeacon: true,
  },
  {
    content: "Use keyboard A key for navigating previous frame and D key for navigating next frame",
    placement: "right",
    target: ".video-container",
    title: "Video Frame Navigation",
    disableBeacon: true,
  },
  {
    content: "Use number keys to select the raw track or order.",
    placement: "left",
    target: ".task-details",
    title: "Select raw track or order",
    disableBeacon: true,
  },
]

export const VALID_INPUT_TYPES = ["text", "number"]
export const ORDER_PREFIX_KEY = "order-v2::"
export const TASK_DETAILS_WIDTH = 390 // Right sidebar width is fixed
export const CAMERAS_STORE_LAYOUT_TYPE = "CAMERAS"
export const CAMERA_PREFIX_KEY = "cam::"
export const THROTTLE_INTERVAL = 30000
export const MAX_ORDERS_PER_BATCH = 50
export const DEFAULT_FRAME_JUMP = 5
export const SIZE_OF_BLUR_BOX = 150
export const STORE_CONFIG_VIDEO_BLUR = "hitl_video_blur_enabled"
export const STORE_CONFIG_VIDEO_CLIPS_ON_CLOUD = "video_clips_on_cloud_window"
export const STORE_CONFIG_DISABLE_TRACKING = "disable_tracking"
export const STORE_CONFIG_RETAILER_VIEW = "retailer_verify_view_enabled"
export const STORE_CONFIG_RETAILER_VERIFY_VIEW_WINDOW = "retailer_verify_view_window_in_days"
export const STORE_CONFIG_HITL_MESSAGE = "hitl_message"
export const DEFAULT_RETAILER_VERIFY_VIEW_WINDOW_IN_DAYS = 30

// platform db roles
export const USER_ROLE_ADMIN = "admin"
export const USER_ROLE_RETAILER = "retailer"

// roles db roles
export const USER_ROLE_HITL_ADMIN = "hitl_admin"
export const USER_ROLE_HITL_OPERATOR = "hitl_operator"
export const USER_ROLE_SUPER_ADMIN = "super_admin"

/**
 * Constants representing different activities mapped to their corresponding numeric values.
 * These values are synchronized with the equivalent MySQL table "operator_activity_types".
 * Any changes or updates to the activities in the MySQL table should be reflected in this data as well.
 */
export const ACTIVITY = {
  TASK_SOLVING: 1,
  CASE_RESEARCH: 2,
  TRAINING: 3,
  BREAK: 4,
  LUNCH_DINNER: 5,
  COACHING: 6,
  ANNOTATION: 7,
  AUDIT: 8,
  LOG_OFF: 9,
}

// Define allowed timeline event types using the constants
export const ALLOWED_TIMELINE_EVENT_TYPES = [
  EVENT_PERSON_SCAN,
  EVENT_PERSON_ENTRY,
  EVENT_LOYALTY,
  EVENT_SHELF_CHANGE,
  EVENT_ITEMS_PURCHASED,
  EVENT_RECEIPT_INPUT,
  EVENT_PERSON_EXIT,
]

export const HITL_USER_ROLES = [
  USER_ROLE_HITL_ADMIN,
  USER_ROLE_HITL_OPERATOR,
  USER_ROLE_SUPER_ADMIN,
  USER_ROLE_ADMIN,
]
